/**
 * จอ kiosk เปิดค้างเป็นวันๆ — ต้อง reload ตัวเองเมื่อมี deploy ใหม่
 *
 * ทำไมต้องมี: ฟิสิกส์และการข้ามฉากรันอยู่บนจอ ถ้าจอเป็นโค้ดเก่า บั๊กที่แก้ไป
 * แล้วก็ยังอยู่บนจอนั้น (เคยไล่บั๊ก "แก้แล้วแต่ยังพัง" อยู่นานเพราะเรื่องนี้)
 *
 * วิธี: build ฝังตรา `__BUILD__` ไว้ในโค้ด และเขียน `version.json` ไว้ข้างกัน
 * จอ fetch ทุก 60 วินาที ตราไม่ตรง = มีของใหม่ → reload
 * โดยรอให้ **ไม่มีผู้เล่นบนจอ** ก่อน ไม่ดับกลางเกม (บังคับ reload ที่ 10 นาที
 * กันกรณีมีคนยืนเล่นแช่ยาว — เกินหน้าต่างนั้นถือว่าความถูกต้องสำคัญกว่า)
 */

const CHECK_MS = 60_000;
const FORCE_AFTER_MS = 10 * 60_000;

export function startAutoReload(build: string, busyNow: () => boolean): void {
  let staleSince = 0;

  const check = async (): Promise<void> => {
    try {
      const res = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
      if (!res.ok) return;
      const j = (await res.json()) as { build?: string };
      if (!j.build || j.build === build) {
        staleSince = 0;
        return;
      }
      if (!staleSince) {
        staleSince = Date.now();
        console.warn(`[autoreload] มี build ใหม่ (${j.build}) — รอจังหวะว่างเพื่อ reload`);
      }
      if (!busyNow() || Date.now() - staleSince > FORCE_AFTER_MS) {
        location.reload();
      }
    } catch {
      // เน็ตหลุดชั่วคราว — รอบหน้าค่อยเช็คใหม่ ห้าม reload ตอนออฟไลน์
    }
  };

  setInterval(() => void check(), CHECK_MS);
}
